.input-quantity-field {
  display: flex;
  align-items: inherit;
  .MuiFormLabel-root {
    right: 0;
    left: initial;
    transform-origin: top right;
    span {
      display: inline-flex;
      align-items: flex-start;
    }
  }
  .input-quantity {
    // max-width: 7.5em;
    min-width: 6em;
    input {
      text-align: right;
    }
  }
  .input-quantity-left-aligned {
    .MuiFormLabel-root {
      right: initial;
      transform-origin: initial;
      span {
        display: inline-flex;
        align-items: flex-start;
      }
    }
    input {
      text-align: left;
    }
  }
  input {
    margin-right: 4px;
  }

  .Mui-disabled {
    padding-right: 0px;
    &.MuiSelect-icon {
      display: none;
    }
  }
}
